import React from "react";
import { IconProps } from "./Icon.types";
import Box from "../../primitives/Box/Box";
import { Body6MediumTypography } from "../../primitives/Typography/typographyVariants";
import FlexColumn from "../Layout/FlexColumn/FlexColumn";
import { IconWrapper } from "./Icon.styles";
import { colorGuide } from "../../theme/colors";

export const Icon = ({
  name,
  onClick,
  state = "default",
  count,
  notificationColor,
  countColor,
  countTextColor,
  ...props
}: IconProps) => {
  return (
    <IconWrapper onClick={onClick} {...props} data-cy={props.dataCy}>
      <i className={name}></i>
      {state === "notification" && (
        <Box
          backgroundColor={notificationColor}
          height="12px"
          width="12px"
          borderRadius="50%"
          px={4}
          py={5}
          border={`1px solid ${colorGuide.lightComponents.icon.borderColor}`}
          position="absolute"
          top="-4px"
          right="-4px"
        />
      )}
      {state === "count" && count && (
        <FlexColumn
          backgroundColor={countColor}
          height="16px"
          width="16px"
          borderRadius="50%"
          px={4}
          py={5}
          border={`1px solid ${colorGuide.lightComponents.icon.borderColor}`}
          position="absolute"
          top="-2px"
          right="-2px"
          alignItems="center"
          justifyContent="center"
        >
          <Body6MediumTypography color={countTextColor}>
            {count}
          </Body6MediumTypography>
        </FlexColumn>
      )}
    </IconWrapper>
  );
};
